import * as actions from './valuations.actions';
import { DatesInterval } from '../../global/interfaces';
import { ValuationsPortfolio, ValuationsPrices, ValuationsTypes, ValuationsFilter, PriceTypes } from './valuations.models';

export interface State {
  loading: boolean;
  dataLoading: boolean;
  dates?: DatesInterval;
  portfolio: ValuationsPortfolio;
  prices: ValuationsPrices[];
  totalPrices: ValuationsPrices[];
  filter: ValuationsFilter;
}

export const initialState: State = {
  loading: false,
  dataLoading: false,
  dates: undefined,
  portfolio: {
    closingBalance: undefined,
    closingActual: undefined,
    funds: []
  },
  prices: [],
  totalPrices: [],
  filter: {
    type: ValuationsTypes.PRICE,
    price: PriceTypes.SELL,
    funds: [ 'total' ],
    fund: [],
    from: undefined,
    to: undefined
  }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_VALUATIONS_DATES:
      return { ...state, loading: true, dates: undefined };
    case actions.ActionTypes.LOAD_VALUATIONS_DATES_SUCCESS:
      return { ...state, loading: false, dates: action.payload };
    case actions.ActionTypes.LOAD_VALUATIONS_DATES_FAILED:
      return { ...state, loading: false, dates: undefined };

    case actions.ActionTypes.LOAD_VALUATIONS_PORTFOLIO:
      return { ...state, dataLoading: true, portfolio: { closingBalance: undefined, closingActual: undefined, funds: [] } };
    case actions.ActionTypes.LOAD_VALUATIONS_PORTFOLIO_SUCCESS:
      return { ...state, dataLoading: false, portfolio: action.payload };
    case actions.ActionTypes.LOAD_VALUATIONS_PORTFOLIO_FAILED:
      return { ...state, dataLoading: false };

    case actions.ActionTypes.LOAD_VALUATIONS_PRICES:
      return { ...state, dataLoading: true, prices: [] };
    case actions.ActionTypes.LOAD_VALUATIONS_PRICES_SUCCESS:
      return { ...state, dataLoading: false, prices: action.payload };
    case actions.ActionTypes.LOAD_VALUATIONS_PRICES_FAILED:
      return { ...state, dataLoading: false };

    case actions.ActionTypes.LOAD_VALUATIONS_TOTAL_PRICES:
      return { ...state, loading: true, totalPrices: [] };
    case actions.ActionTypes.LOAD_VALUATIONS_TOTAL_PRICES_SUCCESS:
      return { ...state, loading: false, totalPrices: action.payload };
    case actions.ActionTypes.LOAD_VALUATIONS_TOTAL_PRICES_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.SET_VALUATIONS_TYPE_FILTER:
      return { ...state, filter: { ...state.filter, type: action.payload } };
    case actions.ActionTypes.SET_VALUATIONS_PRICE_FILTER:
      return { ...state, filter: { ...state.filter, price: action.payload } };
    case actions.ActionTypes.SET_VALUATIONS_FUNDS_FILTER:
      return { ...state, filter: { ...state.filter, funds: action.payload } };
    case actions.ActionTypes.SET_VALUATIONS_FUND_FILTER:
      return { ...state, filter: { ...state.filter, fund: action.payload } };
    case actions.ActionTypes.SET_VALUATIONS_FROM_FILTER:
      return { ...state,
        portfolio: { closingBalance: undefined, closingActual: undefined, funds: [] },
        filter: { ...state.filter, from: action.payload },
        };
    case actions.ActionTypes.SET_VALUATIONS_TO_FILTER:
      return { ...state,
        portfolio: { closingBalance: undefined, closingActual: undefined, funds: [] },
        filter: { ...state.filter, to: action.payload },
      };

    case actions.ActionTypes.RESET_VALUATIONS_FILTER:
      return { ...state, filter: initialState.filter };
    case actions.ActionTypes.RESET_VALUATIONS_DATA:
      return { ...initialState };

    default:
      return state;
  }
}
